'use strict';

var template = require('../templates/LogIn.html');
var loader = require('../helpers/loader');
import Log from 'lib/log';
const log = Log('login-view');
import modal from 'helpers/modal';
const config = require('config');
import axios from 'axios';

const SAVED_USERNAME_KEY = 'savedUsername';

module.exports = Backbone.View.extend({
    el: '.content',

    events() {
        return {
            'submit .js-form': 'login',
            'click .js-sign-in-with-xero-button': 'signInWithXero'
        };
    },

    initialize() {
        this.render();
        const savedUsername = window.localStorage.getItem(SAVED_USERNAME_KEY);
        if (savedUsername) {
            this.$('.js-email').val(savedUsername);
        }
        return this;
    },

    render() {
        this.$el.html(template());
        $('body').addClass('gray-bg');
        this.$('#totpToken').hide();
    },

    login(ev) {
        ev.preventDefault();

        const username = this.$('.js-email').val();
        const password = this.$('.js-password').val();
        const totpToken = this.$('input[name="totpToken"]').val();
        const stopLoader = loader.startFullScreen('.js-login-button');
        const re = new RegExp(
            '^[a-z0-9\u007F-\uffff!#$%&\'*+\/=?^_`{|}~-]+(?:\.[a-z0-9' +
            '\u007F-\uffff!#$%&\'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-' +
            'z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$', 'i'
        );

        if (!re.test(username)) {
            this.$('.js-error')
                .html('Please enter an email address.')
                .show();

            stopLoader();
            return false;
        }

        if (!password) {
            this.$('.js-error')
                .html('The password cannot be empty.')
                .show();

            stopLoader();
            return false;
        }

        const params  = {
            email: username,
            password: password
        };

        if (totpToken) {
            params.totpToken = totpToken;
        }

        this.model.login(params).then(() => {
            this.$('.js-login-button').attr('disabled', 'disabled');
            window.localStorage.setItem(SAVED_USERNAME_KEY, username);
            app.reload();
        }).catch(err => {
            log.error(err);
            if (err.response &&
                err.response.error &&
                err.response.error.statusCode >= 400 &&
                /totp/.test(err.response.error.message)
            ) {
                this.$('#totpToken').show();
                this.$('.js-error')
                    .html(err.response.error.message)
                    .show();
            } else {
                this.$('.js-error')
                    .html('Invalid email or password. Please try again.')
                    .show();
                if (err.response &&
                    err.response.error &&
                    err.response.error.statusCode >= 400 &&
                    /account locked out/.test(err.response.error.message)
                ) {
                    modal.showError(
                        `You have already used 3 attempts to log in. Any \
                        further attempts will be unsuccessful unless you wait \
                        for 5 mins before trying again. Alternatively, you can \
                        reset your password by clicking on "Forgot Password".`,
                        false
                    );
                }
            }
        }).finally(() => stopLoader());

        return false;
    },

    signInWithXero(e) {
        e.preventDefault();
        axios.get(`${config.apiUrl}/Integrations/xero/signinUrl`)
            .then(res => {
                window.location.href = res.data;
            });
        return false;
    }
});



// WEBPACK FOOTER //
// ./app/views/LogIn.js